import { SignIn } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

const PAPER = '#F2EBDC';
const GOLD = '#A67C3A';
const INK = '#1B1814';

export default function SignInScreen() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: PAPER,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div style={{ marginBottom: 24, textAlign: 'center' }}>
        <h1
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: 32,
            fontWeight: 300,
            color: INK,
            margin: '0 0 6px',
          }}
        >
          Rooted
        </h1>
        <p
          style={{
            fontSize: 14,
            color: GOLD,
            fontStyle: 'italic',
            margin: 0,
            fontFamily: 'Georgia, serif',
          }}
        >
          Welcome back
        </p>
      </div>

      <SignIn
        routing="path"
        path="/sign-in"
        fallbackRedirectUrl="/study"
        appearance={{
          variables: {
            colorPrimary: GOLD,
            colorBackground: PAPER,
            colorText: INK,
            fontFamily: 'Georgia, serif',
            borderRadius: '12px',
          },
          elements: {
            card: {
              boxShadow: 'none',
              background: 'transparent',
              border: `1px solid rgba(166,124,58,0.2)`,
              borderRadius: '16px',
              padding: '24px',
            },
            rootBox: { width: '100%', maxWidth: '400px' },
            headerTitle: { display: 'none' },
            headerSubtitle: { display: 'none' },
            socialButtonsBlockButton: { display: 'none' },
            dividerRow: { display: 'none' },
          },
        }}
      />

      <p style={{ marginTop: 16, fontSize: 13, color: INK, opacity: 0.5 }}>
        New to Rooted?{' '}
        <button
          type="button"
          onClick={() => navigate('/sign-up')}
          style={{
            background: 'none',
            border: 'none',
            color: GOLD,
            cursor: 'pointer',
            fontSize: 13,
            textDecoration: 'underline',
          }}
        >
          Begin your journey
        </button>
      </p>
    </div>
  );
}
